module.exports = __webpack_public_path__ + "img/bg_b.9cc0ec04.png";